interface ParsedData {
  label: string;
  value: string;
}

export const parseEventOptions = <T extends { id?: number }>(data: T[], labelKey: keyof T): ParsedData[] =>
  data
    .map((item) => {
      const label = item[labelKey] as unknown as string;
      const value = item.id?.toString();

      return label && value ? { label, value } : undefined;
    })
    .filter((item): item is ParsedData => item !== undefined);
